export const REDUCER_NAME = "socialLinks";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_SOCIALLINKS = `${REDUCER_NAME}/SET_SOCIALLINKS`;
